<template>
  <v-container grid-list-md pa-0>
    <v-layout row wrap>
      <v-flex m12> </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "dashboard",
}
</script>
